// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"872":"67d05d6e","3016":"67d05d6e","3455":"67d05d6e","3742":"762bfcf5","5280":"67d05d6e","7008":"7ce54f66","8777":"fe58350d"}[chunkId] + ".chunk.css";
};